/* eslint-disable no-unused-vars */
import { apolloClient } from "@/setup/apollo-setup";
// import axios from "axios";
import axios from "@/setup/axios-setup";

import * as generic from "@/store/generic/mutations/result-status.js";
import { error } from '@/utils/notification';

import {
    GET_EXAM_LIST,
    ADD_EXAM,
    BULK_ADD_EXAMQUESTION
} from '@/queries/modules/examination/exam.js';

import {
  GET_EXAMQUESTION_LIST_BY_FILTER
} from "@/queries/modules/examination/exam-question";

const state = {
  processing: false,
  error: null,
  success: null,
};

const getters = {};

const mutations = {
  setError: generic.setError,
  setSuccess: (state, payload) => {
    state.error = null;
    state.success = payload;
    state.processing = false;
  },
  setProcessing: generic.setProcessing,
};

const actions = {

  /**
   *  Action to Get Exam List
   *
   *   @param  {Object} context Vuex context object.
   *     @property {Vuex method (Function)} commit : "To commit a mutation"
   *
   */

  // async getExamList({commit}) {
  //   // commit('setProcessing', true);
  //   try {
  //     const result = await apolloClient
  //     .query({
  //       query: GET_EXAM_LIST,
  //       fetchPolicy: 'network-only',
  //       context: { clientName: 'Prisma2' }
  //     })
  //     const { data } = await result;

  //     // TODO: Handle after success;
  //     return { status: { success: true, error: false, message: "" }, data: [ ...data.getExams ] };

  //   } catch (e) {
  //     // commit('setError', error(e));
  //     return { status: { success: false, error: true, message: "", full: e }};
  //   }
  // },

  /**
  *  Action to Get Exam List
   *
   *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
   *
  */

  async getExamQuestionListByFilter({ commit }, payload) {
    // commit('setProcessing', true);
    try {
      const result = await apolloClient
      .query({
        query: GET_EXAMQUESTION_LIST_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      })
      const { data } = await result;

      // TODO: Handle after success;
      return { status: { success: true, error: false, message: "" }, data: [ ...data.getExamQuestionsByFilter ] };

    } catch (e) {
      // commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }};
    }
  },


  /**
  *  Action to Add Exam
   *
   *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
   *
   *   @param  {Object} payload Contain requires inputs for adding data
  *     @property {CourseOutlineRegistrationInput (Array), required} courseOutlineRegistrationInput : [{
          academicPeriodId: "", // {String} Get it from filter selection.
          periodCode: "",       // {String} Get it from filter selection.
          degreeId: "",         // {String} Get it from filter selection.
          subjectGroupId: "",   // {String} Get it from filter selection.
          subjectId: "",        // {String} Get it from Course Outline Selection.
          subjectCode: "",      // {String} "----------------------------------"
          subjectName: "",      // {String} "----------------------------------"
          courseOutlineId: "",  // {String} "----------------------------------"
          teacherId: "",        // {String} "----------------------------------"
          teacherCode: "",      // {String} "----------------------------------"
        }]
   *
  */

  async addExam({ commit }, payload) {
    commit('setProcessing', true);
    try {
      const result = await apolloClient
      .mutate({
        mutation: ADD_EXAM,
        variables: payload,
        context: { clientName: 'Prisma2' }
      })
      const { data } = await result;
      return {
        status: { success: true, error: false, message: "",
        data: data.addExam
      }};

    } catch (e) {
      // commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }}
    }
  },


  /**
    *  Action to Delete Course Outline Registration
   *
   *   @param  {Object} context Vuex context object.
    *     @property {Vuex method (Function)} commit : "To commit a mutation"
   *
   *   @param  {Object} payload Contain requires inputs for adding data
    *     @property {ID (String), required} id : "ID of a Course Outline Registration"
   *
    */

//   async deleteCourseOutlineRegistration({ commit }, payload) {
//     // commit('setProcessing', true);
//     console.log(payload);
//     try {
//       const result = await apolloClient
//       .mutate({
//         mutation: DELETE_COURSEOUTLINEREGISTRATION,
//         variables: payload
//       })
//       const { data } = await result;
//       console.log(data);
//     //   const data = await getCourseOutlineById(payload);
//         // TODO: Handle after success;
//     //   return data;
//     } catch (e) {
//       console.log(e);
//       // commit('setError', error(e));
//       return { status: { success: false, error: true, message: "", full: e }}
//     }
//   },


  /**
    *  Action to Delete Course Outline Registration
   *
   *   @param  {Object} context Vuex context object.
    *     @property {Vuex method (Function)} commit : "To commit a mutation"
   *
   *   @param  {Object} payload Contain requires inputs for adding data
    *     @property {ID (String), required} id : "ID of a Course Outline Registration"
   *
    */

  // async bulkAddExamQuestion({ commit }, payload) {
  //   commit('setProcessing', true);

  //   try {

  //     // Upload with Apollo and GraphQL (still not working)
  //     const result = await apolloClient
  //       .mutate({
  //         mutation: BULK_ADD_EXAMQUESTION,
  //         // variables: payload
  //         variables: payload,
  //         context: { clientName: 'Prisma2' }
  //       });


  //     const {data} = await result;
  //     commit('setSuccess', true);
  //     return data;
  //   //   const data = await getCourseOutlineById(payload);
  //       // TODO: Handle after success;
  //   //   return data;
  //   } catch (e) {
  //     commit('setError', error(e));
  //     return { status: { success: false, error: true, message: "", full: e }}
  //   }
  // },

  /**
    *  Action to Delete Course Outline Registration
   *
   *   @param  {Object} context Vuex context object.
    *     @property {Vuex method (Function)} commit : "To commit a mutation"
   *
   *   @param  {Object} payload Contain requires inputs for adding data
    *     @property {ID (String), required} id : "ID of a Course Outline Registration"
   *
    */

  async uploadExaminationQuestionSpreadsheet({ commit }, payload) {
    // commit('setProcessing', true);
    const formData = new FormData();
    formData.append('file', payload.file);
    formData.append('ext', payload.file.name.substring([payload.file.name.lastIndexOf('.') + 1]));
    formData.append('timestamp', payload.file.lastModified);
    formData.append('operationName', 'exam-question');
    formData.append('id', payload.id);

    try {
      const result = await axios({
        url: 'http://localhost:8082/upload',
        method: 'post',
        headers: {
          'content-type': 'multipart/form-data'
        },
        data: formData
      });
      const {subscribeEndPoint} = result.data;
      const eventSource = new EventSource(`http://localhost:8082/upload${subscribeEndPoint}`);

      eventSource.onmessage = (e) => {
        if (e.lastEventId === "10") {
          eventSource.close();
        }
      }

      /*
      // Upload with Apollo and GraphQL (still not working)
      const result = await apolloClient
        .mutate({
          mutation: UPLOAD_STUDENTENROLL_SPREADSHEET,
          // variables: payload
          variables: { file }
        });
      */

      const {data} = await result;
      //   const data = await getCourseOutlineById(payload);
        // TODO: Handle after success;
      return data;
    } catch (e) {
      // commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }}
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
